<template>

    <div class="checkout_page">
        <!-- Ec breadcrumb start -->
        <div class="sticky-header-next-sec  ec-breadcrumb section-space-mb">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row ec_breadcrumb_inner">
                            <div class="col-md-6 col-sm-12">
                                <h2 class="ec-breadcrumb-title">{{ $t('Your Orders') }}</h2>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <!-- ec-breadcrumb-list start -->
                                <ul class="ec-breadcrumb-list">
                                    <li class="ec-breadcrumb-item"><router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >{{ $t('Home') }}</router-link></li>
                                    <li class="ec-breadcrumb-item active">{{ $t('Your Orders') }}</li>
                                </ul>
                                <!-- ec-breadcrumb-list end -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ec breadcrumb end -->

        <!-- Ec checkout page -->
        <section class="ec-page-content section-space-p">
            <div class="container">
                <div class="row">
                    <div class="ec-checkout-leftside col-lg-8 col-md-12 ">
                        <!-- checkout content Start -->
                        <div class="ec-checkout-content">
                            <div class="ec-checkout-inner">

                                <div class="ec-checkout-pro" v-for="item in order.items">
                                    <div class="col-sm-12 mb-6">
                                        <div class="ec-product-inner d-flex">
                                            <div class="ec-pro-image-outer  pt-0">
                                                <div class=" border rounded-3 p-1">

                                                    <router-link
                                                        :to="{name: 'products.show', params: { id: item?.product?.id, lang : $i18n.locale  }}"
                                                        class="image" v-if="item?.product !== null">

                                                        <img
                                                            :src="item?.product?.image ?? '/images/spices-jar.jpeg'"
                                                            class="main-image" :alt="item?.product?.name"
                                                            width="80">
                                                        <!--                                                    <img :src="item?.product?.image ?? '/images/spices-jar.jpeg'" class="hover-image" :alt="item?.product?.name">-->
                                                    </router-link>

                                                </div>
                                            </div>
                                            <div class="ec-pro-content  pt-0">
                                                <h5 class="ec-pro-title px-0">

                                                    <router-link
                                                        :to="{name: 'products.show', params: { id: item?.product?.id , lang : $i18n.locale  }}">
                                                        {{ item?.product?.name }}
                                                    </router-link>

                                                </h5>
                                                <!--                                            <div class="ec-pro-rating">-->
                                                <!--                                                <i class="ecicon eci-star fill"></i>-->
                                                <!--                                                <i class="ecicon eci-star fill"></i>-->
                                                <!--                                                <i class="ecicon eci-star fill"></i>-->
                                                <!--                                                <i class="ecicon eci-star fill"></i>-->
                                                <!--                                                <i class="ecicon eci-star"></i>-->
                                                <!--                                            </div>-->
                                                <span class="ec-price">
                                                    <span class="new-price">
                                                        {{ $t('Price') }} :
                                                        {{ item?.price }} {{ $t('SAR') }}
                                                    </span>
                                                </span>
                                                <span class="ec-price">
                                                    <span class="new-price">
                                                        {{ $t('Qty') }} :
                                                        {{ item?.quantity }}
                                                    </span>
                                                </span>
                                                <span class="ec-price">
                                                    <span class="new-price">
                                                        {{ $t('Total') }} :
                                                        {{ item?.total_price }} {{ $t('SAR') }}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <!--cart content End -->
                    </div>
                    <!-- Sidebar Area Start -->
                    <div class="ec-checkout-rightside col-lg-4 col-md-12">
                        <div class="ec-sidebar-wrap">
                            <!-- Sidebar Summary Block -->
                            <div class="ec-sidebar-block">
                                <div class="ec-sb-title">
                                    <h3 class="ec-sidebar-title d-flex justify-content-between">
                                        <span>  ملخص الطلب</span>

                                        <span>({{ order?.items?.length }} {{ $t('Items') }} )</span>
                                    </h3>
                                </div>
                                <div class="ec-sb-block-content">
                                    <div class="ec-checkout-summary">

                                        <div>
                                            <span class="text-left">{{ $t('Subtotal') }}</span>
                                            <span class="text-right">{{ order.subtotal }} {{ $t('SAR') }}</span>
                                        </div>
                                        <div>
                                            <span class="text-left">{{ $t('Shipping and delivery') }}</span>
                                            <span class="text-right">{{ order?.shipping_cost }} {{ $t('SAR') }}</span>
                                        </div>
                                        <div>
                                            <span class="text-left">{{ $t('Tax') }}</span>
                                            <span class="text-right">{{ order?.tax_amount }} {{ $t('SAR') }}</span>
                                        </div>
                                        <div class="ec-checkout-summary-total">
                                            <span class="text-left">{{ $t('Total') }}</span>
                                            <span class="text-right">{{ order.total_price }} {{ $t('SAR') }}</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- Sidebar Summary Block -->
                        </div>
                        <div class="ec-sidebar-wrap ec-checkout-del-wrap">
                            <!-- Sidebar Summary Block -->
                            <div class="ec-sidebar-block">
                                <div class="ec-sb-title">
                                    <h3 class="ec-sidebar-title">{{ $t('Shipping Address') }}</h3>
                                </div>
                                <div class="ec-sb-block-content">
                                    <div class="ec-checkout-del">

                                        <ul class="">

                                            <li class="d-block">
                                                <b>{{ order?.address_data?.name }}</b>
<!--                                                <span>{{ order?.address?.city?.name }}</span>-->
                                            </li>

                                            <li class="d-block">
                                                <b>{{ order?.address_data?.description }}</b>
<!--                                                <span>{{ order?.address?.postal_code }}</span>-->
                                            </li>

                                            <li class="d-block">
                                                <b>{{ order?.address_data?.phone }}</b>
<!--                                                <span>{{ order?.address?.phone }}</span>-->
                                            </li>

                                        </ul>

<!--                                        <ul class="summery-total" v-if="order?.delivery !== null">-->
<!--                                            <li>-->
<!--                                                <b class="text-left">{{ $t('Shipment status') }} : </b>-->
<!--                                                <span class="text-right fw-bold">{{-->
<!--                                                        order?.delivery_status_value-->
<!--                                                    }}</span>-->
<!--                                            </li>-->
<!--                                        </ul>-->

                                        <div class="ec-checkout-del-history" v-if="order?.tracking_data?.orderTrackingHistory != null">
                                            <h3 class="ec-sidebar
                                            -title">{{ $t('Shipping History') }}</h3>

                                            <div class="ec-checkout-summary">
                                                <div  v-for="delivery in order?.tracking_data?.orderTrackingHistory ?? []">
                                                    <span class="text-left">
                                                        <b>{{ delivery?.status }}</b> <br>
                                                        {{ delivery?.cityName }}
                                                    </span>
                                                    <span class="text-right">{{ delivery?.actionTime }}</span>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- Sidebar Summary Block -->
                        </div>
                        <div class="ec-sidebar-wrap ec-checkout-pay-wrap">
                            <!-- Sidebar Payment Block -->
                            <div class="ec-sidebar-block">
                                <div class="ec-sb-title d-flex justify-content-between">
                                    <h3 class="ec-sidebar-title">{{ $t('Payment') }}</h3>

                                    <div class="mb-2 fw-bold">{{ order?.payment_status_value }}</div>
                                </div>
                                <div class="ec-sb-block-content">
                                    <div class="ec-checkout-pay pt-3">


                                        <div class="mb-2 fw-bold">{{ $t('Payment method') }}</div>
                                        <ul class="text-end"
                                            v-if="order.payment_status == 'paid'">
                                            <li>{{ order?.transaction?.card?.type }}</li>
                                            <li>{{ order?.transaction?.card?.last4 }}</li>
                                            <li>{{ order?.transaction?.card?.country }}</li>
                                        </ul>

                                        <div class="d-flex justify-content-end">

                                            <a v-if="order?.can_pay === true"
                                               class="btn btn-primary"
                                               :href="'/payment?id=' + order?.id ">
                                                {{ $t('Pay now') }} <i class="fa-solid fa-arrow-left icon"></i>
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- Sidebar Payment Block -->
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    data() {
        return {
            order: []
        }
    },
    created() {

        const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-solid fa-download'});

        axios.get(`orders/${this.$route.params.id}`, {}).then(response => {

            this.order = response.data.data;

            toast.dismiss(id);
        }, response => {
            toast.dismiss(id);
        });
    },
}
</script>
